import { Grid, Typography } from '@mui/material';
import { useTheme } from '@mui/styles';
import { Lock } from '@tassat/icon';
import { muiTheme } from '@tassat/payments-themes';
import * as React from 'react';

import muiStyles from './styles';
import { StatisticWithLabelAndCountProps } from './types';

export default function StatisticWithLabelAndCount(props: StatisticWithLabelAndCountProps) {
    const {
        id,
        className,
        statistic
    } = props;

    const {
        labelStyle,
        statisticStyle,
        countContainer,
        countStyle,
        lockIcon
    } = muiStyles(props);

    const theme = useTheme<typeof muiTheme>();

    return (
        <Grid
            className={className}
            container
            direction='column'
            spacing={0}
            wrap='nowrap'
        >
            <Typography
                className={labelStyle}
                id={id ? `${id}_label` : ''}
                variant='body1'
            >
                {statistic.title}
            </Typography>
            <Grid
                container
                direction='row'
                spacing={0}
                wrap='nowrap'
            >
                <Grid item>
                    <Typography
                        className={statisticStyle}
                        id={id ? `${id}_value` : ''}
                        variant='h4'
                    >
                        {statistic.statistic}
                    </Typography>
                </Grid>
                <Grid
                    className={countContainer}
                    item
                >
                    <Grid
                        alignItems='center'
                        className={countStyle}
                        container
                        direction='row'
                        spacing={0}
                    >
                        <Typography
                            id={id ? `${id}_count` : ''}
                            variant='h6'
                        >
                            {statistic.statisticCount}
                        </Typography>
                        {statistic.lockCount && (
                            <Lock
                                className={lockIcon}
                                iconColor={statistic.statisticCount !== '0' && statistic.statisticCount !== '-' ?
                                    (theme?.app?.applicationColors.lockColor || '#F5824A')
                                    : (theme?.app?.applicationColors.fontColor || '#202020')}
                            />
                        )}
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}